import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import {
  ContentCopy,
  Delete,
  AccountTree,
} from "@mui/icons-material";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const getHandlePosition = (index, total) => {
  const totalItems = total + 1; // +1 para o default
  const spacing = 100 / (totalItems + 1);
  return `${spacing * (index + 1)}%`;
};

const SwitchNode = memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const cases = data?.cases || [];
  const variable = data?.variable || "";

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "12px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        border: "2px solid #E91E63",
        minWidth: "220px",
        position: "relative",
      }}
    >
      {/* Handle de entrada */}
      <Handle
        type="target"
        position="left"
        style={{
          background: "#E91E63",
          width: "12px",
          height: "12px",
          left: "-6px",
          top: "50%",
          transform: "translateY(-50%)",
          border: "2px solid #fff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        }}
        isConnectable={isConnectable}
      />

      {/* Botões de ação */}
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 8,
          top: 8,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "14px", height: "14px", color: "#E91E63" }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "14px", height: "14px", color: "#f44336" }}
        />
      </div>

      {/* Título */}
      <div
        style={{
          color: "#E91E63",
          fontSize: "14px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          marginBottom: "8px",
          paddingRight: "50px",
        }}
      >
        <AccountTree
          sx={{
            width: "18px",
            height: "18px",
            marginRight: "6px",
            color: "#E91E63",
          }}
        />
        Switch
      </div>

      {/* Variável sendo avaliada */}
      <div
        style={{
          fontSize: "11px",
          padding: "6px 8px",
          backgroundColor: "#FCE4EC",
          borderRadius: "4px",
          border: "1px solid #F48FB1",
          marginBottom: "8px",
        }}
      >
        <div style={{ fontWeight: "bold", color: "#C2185B", marginBottom: "2px" }}>
          Variável:
        </div>
        <code style={{ color: "#333", fontSize: "10px" }}>
          {variable || "(não definida)"}
        </code>
      </div>

      {/* Lista de cases */}
      <div
        style={{
          fontSize: "11px",
          width: "100%",
          paddingRight: "30px",
        }}
      >
        {cases.map((caseItem, index) => (
          <div
            key={index}
            style={{
              padding: "6px 8px",
              backgroundColor: "#E3F2FD",
              marginBottom: "4px",
              borderRadius: "4px",
              border: "1px solid #90CAF9",
              position: "relative",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                color: "#1565C0",
                marginBottom: "2px",
              }}
            >
              Case {index + 1}: {caseItem.label || caseItem.value}
            </div>
            <code
              style={{
                display: "block",
                color: "#333",
                fontSize: "10px",
              }}
            >
              = "{caseItem.value}"
            </code>
          </div>
        ))}

        {/* Default */}
        <div
          style={{
            padding: "6px 8px",
            backgroundColor: "#FFF3E0",
            borderRadius: "4px",
            border: "1px solid #FFCC80",
          }}
        >
          <code
            style={{
              display: "block",
              color: "#E65100",
              fontSize: "10px",
              fontWeight: "bold",
            }}
          >
            Default (padrão)
          </code>
        </div>
      </div>

      {/* Handles de saída para cada case */}
      {cases.map((_, index) => (
        <Handle
          key={`handle_case_${index}`}
          type="source"
          position="right"
          id={`case_${index}`}
          style={{
            background: "#2196F3",
            width: "12px",
            height: "12px",
            right: "-6px",
            top: getHandlePosition(index, cases.length),
            border: "2px solid #fff",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}
          isConnectable={isConnectable}
        />
      ))}

      {/* Handle do default */}
      <Handle
        type="source"
        position="right"
        id="default"
        style={{
          background: "#FF9800",
          width: "12px",
          height: "12px",
          right: "-6px",
          top: getHandlePosition(cases.length, cases.length),
          border: "2px solid #fff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});

export default SwitchNode;
